<script setup>
import { Button } from '@dashhudson/dashing-ui/button';

import { useCampaignCreatorInsightsStore } from '@/stores/campaign-creator-insights';
import { useTrackingStore } from '@/stores/tracking';

const props = defineProps({
  selectedMedia: { type: Array, required: true },
  disabled: { type: Boolean, default: false },
  campaignPostFilter: { type: String, default: '' },
  onPostsExcluded: { type: Function, default: null },
  onPostsIncluded: { type: Function, default: null },
});

const emit = defineEmits([
  'onActionComplete',
  'onPostsExcluded',
  'onPostsIncluded',
  'onActionStarted',
]);

const { track } = useTrackingStore();

const campaignCreatorInsightsStore = useCampaignCreatorInsightsStore();

const { includeCampaignCreatorPosts, excludeCampaignCreatorPosts } = campaignCreatorInsightsStore;

async function handleIncludePosts() {
  track('Creator Insights Bulk Posts Included');
  emit('onActionStarted');
  if (props.campaignPostFilter === 'ALL') {
    await includeCampaignCreatorPosts(props.selectedMedia, false);
  } else {
    await includeCampaignCreatorPosts(props.selectedMedia);
  }

  if (props.onPostsIncluded) {
    props.onPostsIncluded();
  } else {
    emit('onPostsIncluded');
  }
}

async function handleExcludePosts() {
  track('Creator Insights Bulk Posts Excluded');
  emit('onActionStarted');
  if (props.campaignPostFilter === 'ALL') {
    await excludeCampaignCreatorPosts(props.selectedMedia, false);
  } else {
    await excludeCampaignCreatorPosts(props.selectedMedia);
  }
  if (props.onPostsExcluded) {
    props.onPostsExcluded();
  } else {
    emit('onPostsExcluded');
  }
}
</script>

<template>
  <Button
    v-if="props.campaignPostFilter !== 'INCLUDED'"
    v-dash-tooltip="'Include Posts in Campaign'"
    size="xs"
    severity="bulk"
    icon="eye"
    :disabled="props.disabled"
    @click="handleIncludePosts"
  />
  <Button
    v-if="props.campaignPostFilter !== 'EXCLUDED'"
    v-dash-tooltip="'Exclude Posts from Campaign'"
    size="xs"
    severity="bulk"
    icon="eye-off"
    :disabled="props.disabled"
    @click="handleExcludePosts"
  />
</template>
